/**
 * SIRET Autofill — RS-Tronic Store
 * Cible : /pages/inscription (formulaire BSS B2B)
 * API : recherche-entreprises.api.gouv.fr (gratuite, officielle, sans clé)
 *
 * Installation :
 *  1. Uploader ce fichier dans Assets du thème Concept
 *  2. Dans layout/theme.liquid avant </body> :
 *     {% if page.handle == 'inscription' %}
 *       {{ 'siret-autofill.js' | asset_url | script_tag }}
 *     {% endif %}
 */

(function () {
  'use strict';

  var FIELD_SIRET   = 'text-field-59e47794915a9';
  var FIELD_COMPANY = 'company-field';
  var FIELD_ADDRESS = 'address-field';
  var FIELD_CITY    = 'city-field';
  var FIELD_ZIP     = 'zip-field';
  var FIELD_COUNTRY = 'country-name';

  var DEBOUNCE_MS = 600;
  var feedbackEl  = null;

  function createFeedback(inputEl) {
    var el = document.createElement('div');
    el.style.cssText = 'font-size:12px;margin-top:4px;padding:4px 8px;border-radius:4px;display:none';
    inputEl.parentNode.insertBefore(el, inputEl.nextSibling);
    return el;
  }

  function showFeedback(msg, type) {
    if (!feedbackEl) return;
    feedbackEl.textContent = msg;
    feedbackEl.style.display    = 'block';
    feedbackEl.style.color      = type === 'success' ? '#1a7a3c' : type === 'error' ? '#c0392b' : '#555';
    feedbackEl.style.background = type === 'success' ? '#eafaf1' : type === 'error' ? '#fdedec' : '#f5f5f5';
  }

  function hideFeedback() {
    if (feedbackEl) feedbackEl.style.display = 'none';
  }

  function fillField(id, value) {
    var el = document.getElementById(id);
    if (!el || !value) return;
    var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    setter.call(el, value);
    el.dispatchEvent(new Event('input',  { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function lookupSiret(siret) {
    showFeedback('Recherche en cours\u2026', 'loading');

    fetch('https://recherche-entreprises.api.gouv.fr/search?q=' + siret + '&limite=1')
      .then(function(res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function(data) {
        if (!data.results || data.results.length === 0) {
          showFeedback('Aucune entreprise trouvée pour ce SIRET.', 'error');
          return;
        }

        var company = data.results[0];
        var siege   = company.siege || {};

        var name    = company.nom_complet || company.denomination || '';
        var address = [siege.numero_voie, siege.type_voie, siege.libelle_voie]
          .filter(Boolean).join(' ');
        var city    = siege.libelle_commune || '';
        var zip     = siege.code_postal     || '';

        fillField(FIELD_COMPANY, name);
        fillField(FIELD_ADDRESS, address);
        fillField(FIELD_CITY,    city);
        fillField(FIELD_ZIP,     zip);
        fillField(FIELD_COUNTRY, 'France');

        showFeedback('\u2713 ' + name, 'success');
      })
      .catch(function(err) {
        console.error('[SIRET Autofill]', err);
        showFeedback('Erreur de recherche. V\u00e9rifiez votre connexion.', 'error');
      });
  }

  function init() {
    var input = document.getElementById(FIELD_SIRET);
    if (!input) return;

    input.setAttribute('maxlength', '14');
    input.setAttribute('inputmode', 'numeric');
    feedbackEl = createFeedback(input);

    var timer = null;

    input.addEventListener('keyup', function () {
      clearTimeout(timer);
      hideFeedback();

      var clean = this.value.replace(/\D/g, '').slice(0, 14);

      if (this.value !== clean) {
        var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        setter.call(this, clean);
        this.dispatchEvent(new Event('keyup', { bubbles: true }));
        return;
      }

      if (clean.length < 14) return;

      var val = clean;
      timer = setTimeout(function() { lookupSiret(val); }, DEBOUNCE_MS);
    });
  }

  function waitForForm() {
    if (document.getElementById(FIELD_SIRET)) {
      init();
    } else {
      setTimeout(waitForForm, 300);
    }
  }

  waitForForm();

})();